import { UseCampaignsHasRecentTriggeredAlertsState } from 'modules/campaigns/lib';
import { useMemo } from 'react';

export const useCampaignTriggeredAlertsMap = (
  campaignTriggeredAlerts?: UseCampaignsHasRecentTriggeredAlertsState['campaignTriggeredAlerts'],
) => {
  return useMemo(
    () =>
      campaignTriggeredAlerts?.reduce(
        (acc, alert) => {
          acc[alert?.campaignId] = alert;
          return acc;
        },
        {} as Record<
          number,
          UseCampaignsHasRecentTriggeredAlertsState['campaignTriggeredAlerts'][0]
        >,
      ),
    [campaignTriggeredAlerts],
  );
};
